import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

// Styled Components
import { SmartContainer, Stack } from '../../../styles/Containers';

// Components
import { StyledP } from '../../../styles/StyledHTML';

// Icons
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { Menu, Tooltip } from '@mui/material';
import { uiStorage } from '../../../redux/UI/ui.actions';
import { IconFile } from '../../Icons';
import { AssetType } from '../../../components/QueryBuilder/AssetType';

export const FilterAssetType = ({ storageKey, options, onChange, value }) => {
  const dispatch = useDispatch();
  const [anchor, setAnchor] = useState(null);

  const openMenu = (event) => setAnchor(event.currentTarget);

  const closeMenu = () => setAnchor(null);

  const handleChange = (newValue) => {
    dispatch(uiStorage({ [storageKey]: newValue }));
    onChange(newValue);
  };

  return (
    <SmartContainer>
      <Tooltip title="Filter By Asset Type" placement="top">
        <StyledIconButton onClick={openMenu}>
          <IconFile />
        </StyledIconButton>
      </Tooltip>
      <Menu
        open={Boolean(anchor)}
        onClose={closeMenu}
        anchorEl={anchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <SmartContainer style={{ margin: '10px' }}>
          <Stack>
            <StyledP>Filter By Asset type</StyledP>
            <AssetType
              value={value}
              onChange={handleChange}
              options={options}
            />
          </Stack>
        </SmartContainer>
      </Menu>
    </SmartContainer>
  );
};
